import {
  AuditProgramAIRDepartmentDTO,
  AuditProgramAIRResponse,
} from 'app/model/audit-program-air-department';
import { Component, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuditProgramAIRDTO } from 'app/model/audit-program-air-dto';
import { AuditProgramAIRItemDocumentDTO } from 'app/model/audit-program-air-item-document-dto';
import { AuditProgramDto } from 'app/model/audit-program-dto';
import { AuditSummaryOutputDto } from 'app/model/audit-summary-output-dto';
import { ComboPopulation } from 'app/model/combo-population';
import { CommonDTO } from 'app/model/common-dto';
import { CommonService } from 'app/service/common.service';
import { CustomMessages } from '@shared';
import { Department } from 'app/model/department';
import { ManageAuditProgarmService } from 'app/service/manage-audit-progarm-service';
import { ManageAuditProgramDto } from 'app/model/manage-audit-program-dto';
import { SidebarComponent } from 'app/theme/admin-layout/sidebar/sidebar.component';
import { ButtonRoleMapResponse } from 'app/model/button-role-map-response-bean';
import { TranslatePipe } from '@shared/pipes/translate.pipe';
import { EasyDialog } from '../easy-dialog/easy-dialog';

@Component({
  selector: 'app-commonair',
  templateUrl: './commonair.component.html',
  styleUrls: ['./commonair.component.scss'],
  providers: [TranslatePipe],
})
export class CommonairComponent implements OnInit {
  buttonRoleMapResponse: ButtonRoleMapResponse[];
  attachmentBtn: boolean = false;
  downloadAllFilesBtn: boolean = false;
  openedairedits = false;
  opened = false;
  openedairFilter = false;

  uploadAuditProgramAirDocFlag: boolean = false;
  editAIRItemFlag: boolean = false;
  airFilterFlag: boolean = false;
  openedfiles: boolean = false;

  auditProgramAIRResponse = new AuditProgramAIRResponse();
  auditProgramAIRDTO = new AuditProgramAIRDTO();
  auditProgramAIRDTOList: AuditProgramAIRDTO[] = [];
  auditProgramAIRItemDocumentDTO: AuditProgramAIRItemDocumentDTO;
  totalAIRCount: number = 0;
  selectedAIRDepartementName = '';
  selectedAIRDept: string = '';
  parsedJson: any;
  commonDTO = new CommonDTO();
  departmentComboList: ComboPopulation[] = [];
  selectedAuditProgramAIRDTO: AuditProgramAIRDTO;
  isDraftReportReleased: number = 0;
  selectedDepartmentId: string;
  selectedIndex: number = 1;
  auditProgramDepartmentList: Department[] = [];
  //auditProgramAuditorDepartmentList: AuditProgramAIRDepartmentDTO[] = [];
  auditProgramAuditorDepartmentList: any = [];
  filterDepartmentList: any[] = [];
  disabledActionButtos: boolean = false;

  @Input() auditProgramMstObj: AuditProgramDto;
  @Input() auditSummaryOutputDto: AuditSummaryOutputDto;
  //FROM AUDITSUMMARY COMPONENT
  @Input() enableAllTransaction: string;
  @Input() checkedPendingAtAuditeeAlso: boolean;

  departmentIdOption: FormControl = new FormControl();

  addAuditProgramAIRForm = new FormGroup({
    departmentId: new FormControl('', Validators.required),
    airDescription: new FormControl('', [Validators.required, Validators.maxLength(1000)]),
    isAttachmentRequired: new FormControl(1, Validators.required),
  });

  addAuditProgramAIRFormDefaultValues: any = {
    departmentId: '',
    airDescription: '',
    isAttachmentRequired: 1,
  };

  constructor(
    private sidebarComponent: SidebarComponent,
    private customMessage: CustomMessages,
    private commonService: CommonService,
    private manageAuditProgarmListService: ManageAuditProgarmService,
    public dialog: EasyDialog,
    private ts: TranslatePipe
  ) {}

  filterDepartment(value) {
    const valueLowerCase = value.toLowerCase();
    this.filterDepartmentList = this.auditProgramAuditorDepartmentList.filter(x =>
      x.departmentName.toLowerCase().includes(valueLowerCase)
    );
  }

  ngOnInit() {
    //this.addAuditProgramAIRForm.controls['departmentId'].disable();
    this.departmentIdOption.valueChanges.subscribe(value => {
      this.filterDepartment(value);
    });
    this.commonDTO.auditProgramId = this.auditProgramMstObj.auditProgramId;
    this.commonDTO.departmentId = '0';
    this.commonDTO.subMenuId = '21'; //screen id for Auditor Bench
    if (Object.keys(this.auditSummaryOutputDto).length == 0) {
      this.auditSummaryOutputDto.actionType = 'PENDINGATAUDITOR';
      this.auditProgramAIRDTO.pendingAtAuditee = '1';
    }

    setTimeout(() => {
      this.auditProgramAIRDTO.auditProgramId = this.auditProgramMstObj.auditProgramId;
      this.auditProgramAIRDTO.statusId = this.auditProgramMstObj.statusId;
      this.auditProgramAIRDTO.airTemplateId = '0';
      this.auditProgramAIRDTO.airItemId = '0';
      this.auditProgramAIRDTO.airDescription = '';
      this.auditProgramAIRDTO.departmentId = '0';
      this.auditProgramAIRDTO.sectionId = '0';
      this.auditProgramAIRDTO.isAttachmentRequired = 1;

      if (this.auditSummaryOutputDto.actionType == 'PENDINGATAUDITOR') {
        this.auditProgramAIRDTO.pending = '1';
      } else {
        this.auditProgramAIRDTO.pending = '0';
      }
      if (this.auditSummaryOutputDto.actionType == 'PARTIALLYPENDING') {
        this.auditProgramAIRDTO.partiallyCompleted = '1';
      } else {
        this.auditProgramAIRDTO.partiallyCompleted = '0';
      }

      if (this.auditSummaryOutputDto.actionType == 'COMPLETED') {
        this.auditProgramAIRDTO.completed = '1';
      } else {
        this.auditProgramAIRDTO.completed = '0';
      }

      if (this.auditSummaryOutputDto.actionType == 'NOTACCEPTED') {
        this.auditProgramAIRDTO.notAccepted = '1';
      } else {
        this.auditProgramAIRDTO.notAccepted = '0';
      }

      if (this.auditSummaryOutputDto.actionType == 'PARTIALLYACCEPTED') {
        this.auditProgramAIRDTO.partiallyAccepted = '1';
      } else {
        this.auditProgramAIRDTO.partiallyAccepted = '0';
      }

      if (this.auditSummaryOutputDto.actionType == 'ACCEPTED') {
        this.auditProgramAIRDTO.accepted = '1';
      } else {
        this.auditProgramAIRDTO.accepted = '0';
      }

      if (this.auditSummaryOutputDto.actionType == 'PENDINGATAUDITEE') {
        this.auditProgramAIRDTO.pendingAtAuditee = '1';
      } else {
        this.auditProgramAIRDTO.pendingAtAuditee = '0';
      }
      if (this.checkedPendingAtAuditeeAlso) {
        this.auditProgramAIRDTO.pendingAtAuditee = '1';
      }

      if (
        this.auditProgramMstObj.isDraftReportReleased == null ||
        this.auditProgramMstObj.isDraftReportReleased == '0'
      ) {
        this.isDraftReportReleased = 0;
        this.disabledActionButtos = false;
      } else {
        this.isDraftReportReleased = 1;
        this.disabledActionButtos = true;
      }
      this.getAuditProgramAuditorDepartmentList();
      this.getAuditProgramAIRList('OnLoad');
      //this.getButtonList();
    }, 500);
  }

  getDepartmentList() {
    this.sidebarComponent.showHideLoader(true);
    this.commonService.getDepartmentList().subscribe(
      data => {
        this.parsedJson = JSON.parse(JSON.stringify(data));
        this.departmentComboList = this.parsedJson;
        this.sidebarComponent.showHideLoader(false);
      },
      error => {
        this.sidebarComponent.showHideLoader(false);
        this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
      }
    );
  }

  /* getAuditProgramDepartmentList() {

    this.sidebarComponent.showHideLoader(true);
    this.commonDTO.auditProgramId = this.auditProgramAIRDTO.auditProgramId;
    this.commonService.getDepListByAuditId(this.commonDTO)
      .subscribe(data => {
        this.parsedJson = JSON.parse(JSON.stringify(data));
        this.auditProgramDepartmentList = this.parsedJson;
        this.sidebarComponent.showHideLoader(false);


      }, (error) => {
        this.sidebarComponent.showHideLoader(false);
        this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
      });
  } */

  getAuditProgramAuditorDepartmentList() {
    this.auditProgramAIRDTO.actionType = 'DL';
    this.manageAuditProgarmListService
      .getAuditProgramAuditorDepartmentList(this.auditProgramAIRDTO)
      .subscribe(
        data => {
          this.parsedJson = JSON.parse(JSON.stringify(data));
          this.auditProgramAuditorDepartmentList = this.parsedJson;
          this.filterDepartmentList = this.auditProgramAuditorDepartmentList;
        },
        error => {
          this.sidebarComponent.showHideLoader(false);
          this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
        }
      );
  }

  getAuditProgramAIRList(type) {
    var abc = new Date().toISOString();
    var mno = new Date(abc);
    this.auditProgramAIRResponse = new AuditProgramAIRResponse();
    this.auditProgramAIRResponse.auditSummaryAIRCountList = [];
    this.auditProgramAIRResponse.auditProgramAIRList = [];
    this.auditProgramAIRResponse.auditProgramAIRDepartmentList = [];

    this.selectedAIRDepartementName = '';
    this.totalAIRCount = 0;
    this.auditProgramAIRDTO.actionType = 'L';
    this.sidebarComponent.showHideLoader(true);
    this.manageAuditProgarmListService.getAuditorBenchAIRList(this.auditProgramAIRDTO).subscribe(
      data => {
        this.parsedJson = JSON.parse(JSON.stringify(data));
        this.auditProgramAIRResponse = this.parsedJson;
        let departmentName = '';
        let departmentId = '';

        if (this.auditProgramAIRResponse.auditProgramAIRList.length == 0) {
          this.sidebarComponent.showHideLoader(false);
          //this.customMessage.showErrorMessage("cams.label.common.noRecordFound", '');
        }
        if (this.auditProgramAIRResponse.auditSummaryAIRCountList.length == 0) {
          this.sidebarComponent.showHideLoader(false);
          //this.customMessage.showErrorMessage("cams.label.common.noRecordFound", '');
        }

        // get air items total count
        this.auditProgramAIRResponse.auditProgramAIRDepartmentList.map((o: any, index) => {
          let count: number = 0;
          count = parseInt(o.airItemCount);
          this.totalAIRCount = this.totalAIRCount + count;

          if (o.departmentId == this.auditProgramAIRDTO.departmentId) {
            departmentName = o.departmentName;
            departmentId = o.departmentId;
          }
        });

        if (
          type == 'OnLoad' &&
          this.auditProgramAIRResponse.auditProgramAIRDepartmentList.length > 0
        ) {
          var loadCount = 0;
          this.auditProgramAIRResponse.auditProgramAIRDepartmentList.forEach(element => {
            if (element.airItemCount > 0 && loadCount == 0) {
              this.selectedDepartmentId = element.departmentId;
              this.commonDTO.departmentId = element.departmentId;
              this.selectedAIRDepartementName = element.departmentName;
              loadCount = 1;
            }
          });

          this.getButtonList();
        } else {
          this.selectedDepartmentId = departmentId;
          this.commonDTO.departmentId = departmentId;
          this.selectedAIRDepartementName = departmentName;

          this.getButtonList();
        }
      },
      error => {
        this.sidebarComponent.showHideLoader(false);
        this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
      }
    );
  }

  viewAIRItemsDeptWise(item: AuditProgramAIRDepartmentDTO) {
    this.auditProgramAIRDTO.departmentId = item.departmentId;
    this.selectedAIRDepartementName = item.departmentName;
    this.getAuditProgramAIRList('click');
  }

  selectairCheckBox(data, event) {
    if (data == 'PENDINGATAUDITOR') {
      if (event.checked) {
        this.auditProgramAIRDTO.pending = '1';
      } else {
        this.auditProgramAIRDTO.pending = '0';
      }
    }
    if (data == 'PENDINGATAUDITEE') {
      if (event.checked) {
        this.auditProgramAIRDTO.pendingAtAuditee = '1';
      } else {
        this.auditProgramAIRDTO.pendingAtAuditee = '0';
      }
    }
    if (data == 'PARTIALLYCOMPLETED') {
      if (event.checked) {
        this.auditProgramAIRDTO.partiallyCompleted = '1';
      } else {
        this.auditProgramAIRDTO.partiallyCompleted = '0';
      }
    }
    if (data == 'COMPLETED') {
      if (event.checked) {
        this.auditProgramAIRDTO.completed = '1';
      } else {
        this.auditProgramAIRDTO.completed = '0';
      }
    }

    if (data == 'NOTACCEPTED') {
      if (event.checked) {
        this.auditProgramAIRDTO.notAccepted = '1';
      } else {
        this.auditProgramAIRDTO.notAccepted = '0';
      }
    }
    if (data == 'PARTIALLYACCEPTED') {
      if (event.checked) {
        this.auditProgramAIRDTO.partiallyAccepted = '1';
      } else {
        this.auditProgramAIRDTO.partiallyAccepted = '0';
      }
    }
    if (data == 'ACCEPTED') {
      if (event.checked) {
        this.auditProgramAIRDTO.accepted = '1';
      } else {
        this.auditProgramAIRDTO.accepted = '0';
      }
    }

    this.auditProgramAIRDTO.departmentId = '0';
    this.getAuditProgramAIRList('OnLoad');
  }

  addAIRItems(actionType: string) {
    let message;
    if (this.addAuditProgramAIRForm.status == 'INVALID') {
      if (this.addAuditProgramAIRForm.get('departmentId').invalid) {
        if (this.addAuditProgramAIRForm.get('departmentId').errors.required) {
          this.customMessage.showErrorMessage('cams.label.common.mandatoryDepartment', '');
          return false;
        }
      }

      if (this.addAuditProgramAIRForm.get('airDescription').invalid) {
        if (this.addAuditProgramAIRForm.get('airDescription').errors.required) {
          this.customMessage.showErrorMessage('cams.label.airScope.mandatoryAirItemName', '');
          return false;
        }

        if (this.addAuditProgramAIRForm.get('airDescription').hasError('maxLength')) {
          message = 'Max length can be 1000 characters';
          this.customMessage.showErrorMessage(133, '');
          return false;
        }
      }
    }

    this.auditProgramAIRDTO.actionType = 'I';
    this.auditProgramAIRDTO.departmentId = this.addAuditProgramAIRForm.get('departmentId').value;
    this.auditProgramAIRDTO.airDescription = this.addAuditProgramAIRForm.get(
      'airDescription'
    ).value;
    this.auditProgramAIRDTO.isAttachmentRequired = this.addAuditProgramAIRForm.get(
      'isAttachmentRequired'
    ).value;
    this.sidebarComponent.showHideLoader(true);
    this.manageAuditProgarmListService
      .auditProgramAIRCrudOperation(this.auditProgramAIRDTO)
      .subscribe(
        data => {
          this.customMessage.showSuccessMessage('cams.label.common.operationCompletedSuccessfully');
          this.addAuditProgramAIRForm.reset(this.addAuditProgramAIRFormDefaultValues);
          this.sidebarComponent.showHideLoader(false);
          this.getAuditProgramAIRList('add');
        },
        error => {
          this.sidebarComponent.showHideLoader(false);
          this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
        }
      );
  }

  showDeleteAIRConfirmation(item: AuditProgramAIRDTO) {
    this.auditProgramAIRDTO.auditProgramId = this.auditProgramMstObj.auditProgramId;
    this.auditProgramAIRDTO.airItemId = item.airItemId;

    let obj = this;
    obj.dialog.confirm(
      obj.ts.transform('cams.label.common.confirm'),
      obj.ts.transform('cams.label.common.confirmationToDeleteAuditProgramAirItem'),
      async function() {
        obj.deleteAuditProgramAIR();
        //dialogRef.disableClose = true;
      },
      function() {
        //ACTION: Do this if user says NO
        //that.name = "No clicked";
      }
    );
  }

  deleteAuditProgramAIR() {
    // this.hideAirDisplayMessage();
    this.auditProgramAIRDTO.actionType = 'D';
    this.auditProgramAIRDTO.airTemplateId = '0';
    this.sidebarComponent.showHideLoader(true);
    this.manageAuditProgarmListService
      .auditProgramAIRCrudOperation(this.auditProgramAIRDTO)
      .subscribe(
        data => {
          this.parsedJson = JSON.parse(JSON.stringify(data));

          if (this.auditProgramAIRResponse.auditProgramAIRList.length > 1) {
            this.getAuditProgramAIRList('delete');
          } else {
            this.auditProgramAIRDTO.departmentId = '0';
            this.getAuditProgramAIRList('OnLoad');
          }

          this.customMessage.showSuccessMessage('cams.label.common.operationCompletedSuccessfully');
          this.sidebarComponent.showHideLoader(false);
        },
        error => {
          this.sidebarComponent.showHideLoader(false);
          this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
        }
      );
  }

  openViewUploadDocument(item: AuditProgramAIRDTO, type) {
    this.auditProgramAIRItemDocumentDTO = new AuditProgramAIRItemDocumentDTO();
    this.auditProgramAIRItemDocumentDTO.auditProgramId = this.auditProgramMstObj.auditProgramId;
    this.auditProgramAIRItemDocumentDTO.airItemId = item.airItemId;
    this.auditProgramAIRItemDocumentDTO.airDescription = item.airDescription;
    this.auditProgramAIRItemDocumentDTO.auditorAction = item.auditorAction;
    this.auditProgramAIRItemDocumentDTO.auditeeAction = item.auditeeAction;
    this.auditProgramAIRItemDocumentDTO.tabType = type;
    this.auditProgramAIRItemDocumentDTO.departmentId = this.selectedDepartmentId;
    this.auditProgramAIRItemDocumentDTO.auditeeRemarks = item.auditeeRemarks;
    this.auditProgramAIRItemDocumentDTO.auditorRemarks = item.auditorRemarks;
    this.auditProgramAIRItemDocumentDTO.auditorActionId = item.auditorActionId;
    this.auditProgramAIRItemDocumentDTO.auditorLastComment = item.auditorLastComment;
    this.auditProgramAIRItemDocumentDTO.auditeeLastComment = item.auditeeLastComment;
    this.auditProgramAIRItemDocumentDTO.auditeeLastCommentTime = item.auditeeLastCommentTime;
    this.auditProgramAIRItemDocumentDTO.auditorLastCommentTime = item.auditorLastCommentTime;
    this.uploadAuditProgramAirDocFlag = true;
    if (type == 'auditor' || type == 'all') {
      this.selectedIndex = 0;
    } else {
      this.selectedIndex = 1;
    }

    this.openedfiles = !this.openedfiles;
    this.opened = !this.opened;
  }

  refreshAIRList(auditProgramAIRDTO: AuditProgramAIRDTO) {
    this.auditProgramAIRDTO.departmentId = auditProgramAIRDTO.departmentId;
    this.getAuditProgramAIRList('Add');
  }

  editItem(item) {
    this.selectedAuditProgramAIRDTO = new AuditProgramAIRDTO();
    this.editAIRItemFlag = true;
    this.openedairedits = !this.openedairedits;

    this.selectedAuditProgramAIRDTO.auditProgramId = this.auditProgramMstObj.auditProgramId;
    this.selectedAuditProgramAIRDTO.airItemId = item.airItemId;
    this.selectedAuditProgramAIRDTO.departmentId = this.selectedDepartmentId;
    this.selectedAuditProgramAIRDTO.airDescription = item.airDescription;
    this.selectedAuditProgramAIRDTO.isAttachmentRequired = item.isAttachmentRequired;
    if (item.isAttachmentRequired == 1) {
      this.selectedAuditProgramAIRDTO.selectedAttachmentReq = true;
    } else {
      this.selectedAuditProgramAIRDTO.selectedAttachmentReq = false;
    }
  }

  closededits(evt: boolean) {
    this.openedairedits = evt;
  }

  closed(evt: boolean) {
    this.uploadAuditProgramAirDocFlag = evt;
    this.opened = evt;
  }

  closePanelAirAttachment(auditProgramAIRDTO: AuditProgramAIRDTO) {
    this.auditProgramAIRDTO.departmentId = auditProgramAIRDTO.departmentId;
    this.getAuditProgramAIRList('Add');

    this.uploadAuditProgramAirDocFlag = false;
    this.opened = false;
  }

  applyFreeSearch() {
    this.airFilterFlag = true;
    this.openedairFilter = !this.openedairFilter;
  }

  getFilterValues(auditProgramAIRDTO: AuditProgramAIRDTO) {
    this.auditProgramAIRDTO.auditorAction = auditProgramAIRDTO.auditorAction;
    this.auditProgramAIRDTO.auditeeAction = auditProgramAIRDTO.auditeeAction;
    this.auditProgramAIRDTO.departmentId = this.selectedDepartmentId;
    this.getAuditProgramAIRList('search');
  }

  closedairfilter(evt: boolean) {
    this.openedairFilter = evt;
  }

  trackByMethodAIR = (_index: number, item: any) => {
    if (_index + 1 == this.auditProgramAIRResponse.auditProgramAIRList.length) {
      this.sidebarComponent.showHideLoader(false);
    }
    return item.airItemId;
  };

  getButtonList() {
    if (this.commonDTO.departmentId == null || this.commonDTO.departmentId == '') {
      this.commonDTO.departmentId = '0';
      this.buttonMapping();
    } else {
      this.buttonMapping();
    }
  }

  buttonMapping() {
    this.commonService.getButtonRoleMapList(this.commonDTO).subscribe(
      data => {
        this.parsedJson = JSON.parse(JSON.stringify(data));
        this.buttonRoleMapResponse = this.parsedJson.resultList;
        this.enableAllTransaction = '0';
        for (let i = 0; i < this.buttonRoleMapResponse.length; i++) {
          if (
            this.buttonRoleMapResponse[i].functionId == '28' &&
            this.buttonRoleMapResponse[i].enableAllTransaction == '1'
          ) {
            this.attachmentBtn = true;
            this.enableAllTransaction = '1';
          } else if (this.buttonRoleMapResponse[i].functionId == '32') {
            this.downloadAllFilesBtn = true;
          }
        }
      },
      error => {
        this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
      }
    );
  }
}
